<template>
  <MountingPortal mountTo="#portals" append>
    <slot />
  </MountingPortal>
</template>

<script>
import { MountingPortal } from 'portal-vue'
export default {
  components: {
    MountingPortal,
  },
}
</script>
